<template>
    <div>
        <Popular/>
    </div>
</template>

<script>
import Popular from '../components/Popular.vue'
    export default {
        components: { 
            Popular 
        },
    }
</script>

